var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex",class:{ 'flex-column': _vm.orientation === 'vertical' }},_vm._l((_vm.links),function(link,i){return _c('div',{key:i,class:_vm.headerLinkItemClasses},[_c('common-link',{staticClass:"header-link",class:_vm.commonLinkClasses,attrs:{"link":link}},[_vm._v(" "+_vm._s(link.text)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }